import { dateToStringTime, type IBasicUser, type IChatLiteMessage } from '@repo/sdk'
import { KitAvatar } from '@repo/ui'
import { CheckCheckIcon, CheckIcon } from 'lucide-react'

import { cn } from '../../lib'

interface IProps {
  message: IChatLiteMessage
  prevMessage: IChatLiteMessage
  userData: Partial<IBasicUser>
}
export const Message = ({ message, prevMessage, userData }: IProps) => {
  const lastMessageInSeries = !prevMessage || prevMessage.user.id !== message.user.id
  const isYourMessage = message.user.id === userData.id

  return (
    <div className={cn('flex', isYourMessage && 'flex-row-reverse')}>
      {lastMessageInSeries && !isYourMessage && (
        <KitAvatar
          avatarUrl={message.user.avatar?.url}
          userData={{ last_name: message.user.last_name, name: message.user.name! }}
        />
      )}
      <div>
        <div
          className={cn(
            isYourMessage ? 'bg-blue-100' : 'bg-gray-100',
            !lastMessageInSeries && !isYourMessage ? 'ml-12' : 'ml-0',
            'mt-0 p-3',
            'flex flex-row gap-2',
            'rounded-lg',
            'text-sm text-black',
            'max-w-[calc(100% - 96px)]',
            'show',
          )}
        >
          <p className={'w-full break-words'}>{message.message}</p>
          <div className={'flex items-end'}>
            <p className={'self-end text-nowrap text-[10px] opacity-[33%]'}>
              {dateToStringTime(new Date(message.created_at))}
            </p>
            {isYourMessage && <MessageTicks message={message} />}
          </div>
        </div>
        {!isYourMessage && lastMessageInSeries && (
          <small className="ml-1 font-bold text-slate-600">
            {message.user.name} {message.user.last_name}
          </small>
        )}
      </div>
    </div>
  )
}

const MessageTicks = ({ message }: { message: IChatLiteMessage }) => {
  const size = 16

  if (!message.id) {
    return <CheckIcon color="gray" size={size} />
  }

  if (message.read_at) {
    return <CheckCheckIcon color="green" size={size} />
  }

  return <CheckCheckIcon color="gray" size={size} />
}
